import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Modal, Button, ModalBody, Row, Col, FloatingLabel } from 'react-bootstrap';
import { Control } from 'react-redux-form';
import { requestDetailsActions } from '../../../store/external/request-reducer/request-details.reducer';
import { csatActions } from '../../../store/external/csat-survey-reducer/csat-survey.reducer';
import { CSAT_SETTINGS } from '../../../constants/external-constants';

import { ModalHeaderOrderRequestDetail as ModalHeader } from '../../common/modal/modal-head.component';

class CSATModal extends Component {

    handleClose = () => {
        this.props.toggleSurveyModal();
    }

    handleSubmit = async (e) => {
        e.preventDefault();
        const { selectedItem } = this.props.requestDetail;
        var success = await this.props.submitCsat(e);
        if (success) {
            this.props.isShowSurvey(selectedItem, true);
            this.props.handleShowCompletion();
        }
    }

    componentDidMount(){
        const { selectedItem } = this.props.requestDetail;
        this.props.resetShowCompletion();
        this.props.fetchCsatSurvey(selectedItem);
    }

    loading = () => {
        return (
            <div className="loading-request-details-holder width-100 text-align-center">
                <div className="lds-default">
                    <div></div>
                    <div></div>
                    <div></div>
                    <div></div>
                    <div></div>
                    <div></div>
                    <div></div>
                    <div></div>
                    <div></div>
                    <div></div>
                    <div></div>
                    <div></div>
                </div>
            </div>
        );
    }

    renderSurvey = () => {
        const { surveyModel, disableSubmit } = this.props.csatSurveyRequest;
        return (
            <div className="margin-20">
                {this.renderQuestions()}
                <div className='csat-comment-container'>
                    <label htmlFor={CSAT_SETTINGS.lbl_comments}>{CSAT_SETTINGS.lbl_comments}</label>
                    <Control.textarea
                            as="textarea"
                            model="csat-comment"
                            id="csat-comment"
                            className="form-control"
                            maxLength={255}
                            value={surveyModel.filter(x => x.questionID == 1).comment}
                            onChange={this.props.setCsatFormData}
                        //changeAction={onChangeAction !== undefined ? this.onChangeAction : undefined}
                        />
                </div>
                <Row>
                    <Button
                        id="csat-submit-btn"
                        disabled={disableSubmit}
                        onClick={e => { this.handleSubmit(e) }}>
                        Submit
                    </Button>
                </Row>
            </div>
        );
    }

    renderQuestions = () => {
        const { csatQuestions = [], csatSurvey = [] } = this.props.csatSurveyRequest;
    
        const questionsToRender = csatSurvey.length > 0 ? csatSurvey : csatQuestions;

        return questionsToRender.map((q, i) => {
            const isSurvey = csatSurvey.length > 0;
            const questionText = isSurvey ? q.QuestionText : q.Question;
            
            if (isSurvey && q.Rate === 0) {
                return null;
            }

            return (
                <div key={i} className="word-wrap-break">
                    <Row>
                        <div><span>{i + 1}. {questionText}</span></div>
                    </Row>
                    <Row>
                        {isSurvey ? this.renderCsatSurvey(q) : this.renderOptions(q)}
                    </Row>
                </div>
            );
        });
    }

    renderOptions = (question) => {
        const { csatRateTypes } = this.props.csatSurveyRequest;
    
        return csatRateTypes
            .filter(rateType => rateType.CSATRateID !== 0)
            .map(rateType => (
                <Col key={rateType.CSATRateID} lg="12">
                    <div className="margin-bottom-10 margin-top-10 margin-left-25">
                        <input 
                            className="cursor-pointer height-unset-imp width-unset-imp margin-right-5 v-align-middle" 
                            type="radio" 
                            id={question.questionID} 
                            value={rateType.CSATRateID} 
                            name={question.Question} 
                            onClick={(e) => this.props.setCsatFormData(e, question)} 
                        />
                        <span>{rateType.CSATRateName}</span>
                    </div>
                </Col>
            ));
    }

    renderCsatSurvey = (question) => {
        const { csatRateTypes, csatSurvey } = this.props.csatSurveyRequest;
    
        const isOptionChecked = (questionText, rateID) => 
            csatSurvey.some(data => data.QuestionText === questionText && data.Rate === rateID);
        
        return csatRateTypes.map(rateType => (
            <Col key={rateType.CSATRateID} lg="12">
                <div className="margin-bottom-10 margin-top-10 margin-left-25">
                    <input 
                        className="cursor-pointer height-unset-imp width-unset-imp margin-right-5 v-align-middle" 
                        type="radio" 
                        id={`${question.OrderID}-${rateType.CSATRateID}`} 
                        value={rateType.CSATRateID} 
                        name={question.QuestionText} 
                        disabled
                        checked={isOptionChecked(question.QuestionText, rateType.CSATRateID)} 
                        onChange={(e) => this.props.setCsatFormData(e, question)} 
                    />
                    <span>{rateType.CSATRateName}</span>
                </div>
            </Col>
        ));
    }
    

    renderCsatComment = () =>{
        const { csatSurvey } = this.props.csatSurveyRequest;
        const comment = () => {
            const commentData = csatSurvey.find(data => data.Rate === 0);
            return commentData ? commentData.Comment : ""; 
        };

        return (
            <div className="margin-20">
                {this.renderQuestions()}
                <div>
                    <div className='csat-comment-container disable'>
                        <label htmlFor={CSAT_SETTINGS.lbl_comments}>{CSAT_SETTINGS.lbl_comments}</label>
                            <Control.textarea
                                    as="textarea"
                                    model="csat-comment"
                                    id="csat-comment"
                                    className="form-control height-100"
                                    maxLength={255}
                                    disabled
                                    value={comment()} // Set the value of the textarea using the modified helper function
                                    onChange={this.props.setCsatFormData}
                                />
                    </div>
                </div>
            </div>
        );
        }

    render() {
        
        const { isShowCompletion, isShow, isLoading, csatSurvey } = this.props.csatSurveyRequest; 

        return (
            <div>
                <Modal className="csat-modal popupover-dialog"
                    backdropClassName="popupover-backdrop"
                    show={isShow}
                    onEnter={this.props.fetchCsatQuestions}
                    dialogClassName="modal-25w center"
                    backdrop="static"
                    onHide={this.props.handleHideSurvey}
                >
                    <ModalHeader title={CSAT_SETTINGS.lbl_title} />
                    <ModalBody>
                        <Row className="csat-row">
                            {isShowCompletion ?
                                <div className="text-align-center font-size-20">
                                    <span>{CSAT_SETTINGS.lbl_completionVerbiage}</span>
                                </div>
                                :
                                <div>
                                    <Row>
                                        <span>{CSAT_SETTINGS.lbl_surveyVerbiage}</span>
                                    </Row>
                                    <div className="margin-top-20 margin-bottom-20">
                                        <Row>
                                            <Col>
                                                <span className="color-red font-weight-bold">*</span><span className="font-weight-bold">{CSAT_SETTINGS.lbl_required}</span>
                                            </Col>
                                        </Row>
                                    </div>
                                    {isLoading ? this.loading() : csatSurvey.length > 0 ? this.renderCsatComment() : 
                                    this.renderSurvey()
                                    }
                                </div>
                            }
                        </Row>

                    </ModalBody>
                </Modal>
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    const { csatSurveyRequest, requestDetail } = state;
    return {
        csatSurveyRequest,
        requestDetail
    };
}

export default connect(
    mapStateToProps,
    dispatch => bindActionCreators(Object.assign({}, csatActions, requestDetailsActions), dispatch)
)(CSATModal);

